export const UNKNOWN_SORT_PROPERTY = 'UNKNOWN_SORT_PROPERTY';

/**
 * Matches both shapes the same backend error arrives in: the raw HttpErrorResponse seen by the
 * interceptor (`err.error.error`) and the unwrapped body the interceptor rethrows (`error.error`).
 * Keeping both in one guard means a change to the interceptor's rethrow cannot silently break the
 * data-table's sort recovery.
 */
export function isUnknownSortPropertyError(error: unknown): boolean {
  if (!error || typeof error !== 'object') {
    return false;
  }
  const body = (error as { error?: unknown }).error;
  if (body === UNKNOWN_SORT_PROPERTY) {
    return true;
  }
  return !!body && typeof body === 'object' && (body as { error?: unknown }).error === UNKNOWN_SORT_PROPERTY;
}
